import React from 'react';
import {Glob as G} from "../libs/Glob.mjs";
import LanguageSwitcher from "../controls/LanguageSwitcher.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import {Button, ButtonGroup} from "reactstrap";
import "./MainMenu.css";
import appLib from "../libs/appLib.mjs";

const MainMenu = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: G.getLanguage(),
			groups: G.getUserLoginGroups() || []
		};
		this.uid = G.generateUid('ChooseGroup');
	}
	componentDidMount() {
		appLib.group(false);
		G.trigger('pageButtons');
		G.setStatus('pageTitle', G.label('Main menu', ));
		G.register('Prefs', () => {
			const l = G.getLanguage();
			if ( l && l !== this.state.lang ) {
				this.setState({lang: l});
				G.setStatus('pageTitle', G.label('Main menu', ));
			}
		}, this.uid);
		G.register('userLoginGroups', g => {
			this.setState({groups: g});
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister( this.uid);
	}
	render() {
		return(
			<div className="MainMenu" id={this.uid} key={this.state.lang}>
				<div className="LanguageSwitcherContainer">
					<LanguageSwitcher/>
				</div>
				<div className={'Chooser'}>
					<h4>
						<TextLabel value={"MainMenuIntro"}/>
					</h4>
					<ButtonGroup vertical={true}>
						{this.state.groups.map(g => (
							<Button
								color={ 'link' }
								key={g.id}
								onClick={() => {
									appLib.group( g.id );
									G.setCurrentPageParam('group', g.id);
								}}
							>
								{ g.name }
							</Button>
						))}
					</ButtonGroup>
				</div>
			</div>
		)
	}
}

export default MainMenu;